export default __webpack_public_path__ + "static/media/majesticons_analytics-line.97a3cda5.svg";